export abstract class Component {
  private unsubs: Array<() => void> = [];
  protected el!: HTMLElement;

  abstract render(): HTMLElement;

  mount(parent: HTMLElement): void {
    this.el = this.render();
    parent.appendChild(this.el);
  }

  unmount(): void {
    this.unsubs.forEach((fn) => fn());
    this.unsubs = [];
    this.el?.remove();
  }

  protected track(unsub: () => void): void {
    this.unsubs.push(unsub);
  }
}
